import React from 'react'
import loaderGif from '../../imagenes/loader-nuevo.gif'

const Loader = (props) => {

  if (!props.loaded) {
        return (
          <div id="loader" className="loader result">
            <div>
              <img src={loaderGif} alt="Buscando" />
            </div>
            <h4>{props.mensaje}</h4>
          </div>
              );
            } else {
              return null;
            }
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Global/Loader.js